import React from 'react';
import { BookOpen, Upload, Sparkles, Brain, RefreshCcw, Award, ChevronRight, ArrowRight } from 'lucide-react';
import { trackStudentCTA } from '../../services/analytics';

const HowItWorksStudents = ({ isDarkMode, onGetStarted }) => {
  const handleCTAClick = () => {
    trackStudentCTA('how_it_works_students');
    onGetStarted('student');
  };

  const steps = [
    { step: '01', icon: Upload, title: 'Upload Any Material', desc: 'PDFs, lecture notes, textbook photos, or audio recordings.' },
    { step: '02', icon: Sparkles, title: 'AI Generates Quiz', desc: 'Multiple-choice, true/false, short answer, or fill-in-the-blank.' },
    { step: '03', icon: Brain, title: 'Practice & Solve', desc: 'Get immediate feedback and step-by-step AI explanations.' },
    { step: '04', icon: RefreshCcw, title: 'Master Mistakes', desc: 'Review decks isolate wrong answers until 100% mastery.' },
    { step: '05', icon: Award, title: 'Ace Your Exams', desc: 'Test readiness with NECTA, IGCSE, SAT, IELTS presets.' }
  ];

  return (
    <section data-testid="section-how-it-works-students" id="students-section" className={`py-16 md:py-24 ${isDarkMode ? 'bg-[#131C2E]' : 'bg-white'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className={`inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-bold mb-4 ${isDarkMode ? 'text-sky-400' : 'text-sky-600'}`}>
            <BookOpen className="w-4 h-4" />
            For Students
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-['Outfit'] tracking-tight mb-4">
            How AIQuizPark Works for Students
          </h2>
          <p className={`text-base sm:text-lg max-w-2xl mx-auto ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
            Transform any study material into active practice in 5 simple steps
          </p>
        </div>

        <div className="grid md:grid-cols-5 gap-4">
          {steps.map((item, i) => (
            <div key={i} data-testid={`student-step-${item.step}`} className={`relative p-5 rounded-xl text-center ${isDarkMode ? 'bg-slate-800/50 border border-slate-700' : 'bg-slate-50 border border-slate-200'}`}>
              <div className={`inline-flex items-center justify-center w-12 h-12 rounded-xl mb-4 ${isDarkMode ? 'bg-sky-900/50' : 'bg-sky-100'}`}>
                <item.icon className={`w-6 h-6 ${isDarkMode ? 'text-sky-400' : 'text-sky-600'}`} />
              </div>
              <div className={`text-xs font-bold uppercase tracking-wider mb-2 ${isDarkMode ? 'text-sky-400' : 'text-sky-600'}`}>Step {item.step}</div>
              <h3 className="text-sm sm:text-base font-bold mb-2">{item.title}</h3>
              <p className={`text-xs sm:text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>{item.desc}</p>
              {i < 4 && (
                <div className="hidden md:block absolute top-1/2 -right-2 transform -translate-y-1/2">
                  <ChevronRight className={`w-4 h-4 ${isDarkMode ? 'text-slate-600' : 'text-slate-300'}`} />
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <button 
            onClick={handleCTAClick} 
            data-testid="student-section-cta" 
            className="px-8 py-4 bg-gradient-to-r from-sky-500 to-sky-600 text-white rounded-xl font-bold text-lg hover:-translate-y-1 transition-all shadow-xl shadow-sky-500/30 inline-flex items-center gap-2"
          >
            Start Learning Free <ArrowRight className="w-5 h-5" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksStudents;
